<mat-form-field
  appearance="outline"
  [floatLabel]="floatLabel"
>
  <mat-label *ngIf="label">
    {{ label }}
  </mat-label>

  <input
    matInput
    [type]="passwordHide ? 'password' : 'text'"
    [formControl]="control"
    [placeholder]="placeholder"
    [attr.disabled]="isDisabled"
    [value]="value"
    (blur)="onBlur($event)"
  />
  <button
    *ngIf="placeholder === 'Enter your password'"
    mat-icon-button
    type="button"
    matSuffix
    (click)="passwordHide = !passwordHide"
    [attr.aria-label]="'Hide password'"
    [attr.aria-pressed]="passwordHide"
  >
    <mat-icon>{{ passwordHide ? "visibility_off" : "visibility" }}</mat-icon>
  </button>
  <mat-error>
    <ng-content select="[error]"></ng-content>
  </mat-error>
</mat-form-field>
